/* eslint-disable no-control-regex */
/* eslint-disable require-unicode-regexp */
/* eslint-disable id-length */

const SPECIAL_CASES: Record<string, string> = {
   ł: 'l',
   Ł: 'L',
   ø: 'o',
   Ø: 'O',
   đ: 'd',
   Đ: 'D',
   ß: 'ss',
   æ: 'ae',
   Æ: 'AE',
   þ: 'th',
   Þ: 'TH',
   '©': '(c)',
   '®': '(r)',
   '€': 'EUR',
   '≈': '~',
   '«': '"',
   '»': '"',
   ' ': ' ',
};

export function foldToASCII(str: string): string {
   return str
      .split('')
      .map((char) => SPECIAL_CASES[char] || char)
      .join('')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\x00-\x7F]/g, '');
}
